import { useEffect, useState } from 'react'
import PeriodontalChart from './components/PeriodontalChart'
import MobilePhotoCapture from './components/MobilePhotoCapture'
import MobilePDFReceiver from './components/MobilePDFReceiver'
import MobileQRScanner from './components/MobileQRScanner'

function App() {
  const [mode, setMode] = useState('desktop') // 'desktop', 'mobile-photo', 'mobile-pdf', 'mobile-scan'
  const [peerId, setPeerId] = useState(null)

  useEffect(() => {
    // Check URL parameters for mobile modes
    const params = new URLSearchParams(window.location.search)
    const photoMode = params.get('photo')
    const pdfMode = params.get('pdf')
    const scanMode = params.get('scan')
    const peerIdParam = params.get('peer')

    if (photoMode === '1' && peerIdParam) {
      setMode('mobile-photo')
      setPeerId(peerIdParam)
    } else if (pdfMode === '1' && peerIdParam) {
      setMode('mobile-pdf')
      setPeerId(peerIdParam)
    } else if (scanMode === '1' && peerIdParam) {
      setMode('mobile-scan')
      setPeerId(peerIdParam)
    }
  }, [])

  if (mode === 'mobile-photo' && peerId) {
    return <MobilePhotoCapture peerId={peerId} />
  }

  if (mode === 'mobile-pdf' && peerId) {
    return <MobilePDFReceiver peerId={peerId} />
  }

  if (mode === 'mobile-scan' && peerId) {
    return <MobileQRScanner peerId={peerId} />
  }

  return <PeriodontalChart />
}

export default App
